import styles from "./style.module.scss";
import formatTextUpperCase from "../../../../../helpers/formatTextUpperCase";

type IProps = {
  planName: string;
  planAmount: string;
  planAmountPerMonth: string;
  planDetails: string;
  onHandleDeactivatePlan: VoidFunction;
  onHandleUpdatePlan: VoidFunction;
  leftDay: number;
};

export default function HasSubscriptionCard({
  planName,
  planAmount,
  planAmountPerMonth,
  planDetails,
  onHandleUpdatePlan,
  onHandleDeactivatePlan,
  leftDay
}: Readonly<IProps>) {
  return (
    <div className={styles.currentPlanCard}>
      <div className={styles.content}>
        <p className="text-lg">{formatTextUpperCase(planName)}</p>
        <div className={styles.planDescription}>
          <p className="text-xs">
            <span className={styles.amount}>{planAmountPerMonth}</span>
            <span className="mobile:opacity-50"> /month</span>
          </p>
          <p className="desktop:pl-4">
            <span className={styles.details}>{planAmount}:&nbsp;</span>
            <span className={styles.details}>{planDetails}</span>
          </p>
        </div>
      </div>

      <div className={styles.leftDays}>
        <span>{leftDay} Days Left</span>
      </div>

      <div className={styles.buttonGroup}>
        <button className={styles.billingBackground} onClick={onHandleDeactivatePlan}>
          <span className={styles.billingButton}>DEACTIVATE MY ACCOUNT</span>
        </button>
        <button className={styles.billingBackground} onClick={onHandleUpdatePlan}>
          <span className={styles.billingButton}>UPDATE BILLING INFO</span>
        </button>
      </div>
    </div>
  );
}
